import { render, staticRenderFns } from "./AddBannerPage.vue?vue&type=template&id=38da6231&scoped=true&"
import script from "./AddBannerPage.vue?vue&type=script&lang=js&"
export * from "./AddBannerPage.vue?vue&type=script&lang=js&"
import style0 from "./AddBannerPage.vue?vue&type=style&index=0&id=38da6231&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38da6231",
  null
  
)

export default component.exports